<script lang="ts">
  // Parsed-operator chips (spec §9 item 4) + save button + scan-limited warning.
  import { t, type I18nKey } from '$lib/i18n';
  import { CHIP_LABEL_KEYS } from '$lib/search/grammar';
  import { prompt, store } from '$lib/store';

  function chipText(key: string, label: string): string {
    const k = CHIP_LABEL_KEYS[key];
    const name = k ? t(k as I18nKey) : key;
    return label ? `${name}: ${label}` : name;
  }

  async function save() {
    const q = store.searchQ.trim();
    if (!q) return;
    const name = await prompt({ title: t('saveSearch'), value: q.slice(0, 40), placeholder: t('searchNamePrompt'), ok: t('save') });
    if (name) await store.saveSearch(name);
  }
</script>

<div class="qchips" role="status">
  {#each store.searchChips as c (c.key + ':' + c.label)}
    <span class="qchip" data-key={c.key}>{chipText(c.key, c.label)}</span>
  {/each}
  {#if store.searchQ.trim()}<button type="button" class="qchip save" onclick={save}>{t('saveSearch')}</button>{/if}
  {#if store.searchTruncated}<span class="qchip warn">{t('scanLimited', { n: store.searchScanned ?? 0 })}</span>{/if}
</div>

<style>
  /* @css list/QueryChips start */
  .qchips {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
    padding: var(--space-2) var(--space-3) 0
  }

  .qchip {
    display: inline-flex;
    align-items: center;
    padding: 2px var(--space-3);
    border-radius: var(--radius-pill);
    background: var(--surface-sunken);
    border: 1px solid var(--border-default);
    color: var(--text-body);
    font-size: var(--text-xs)
  }

  .qchip.warn {
    border-color: var(--border-warning, var(--border-default))
  }

  .qchip.save {
    border: 1px dashed var(--border-default);
    background: none;
    cursor: pointer;
    color: var(--text-body);
    font: inherit
  }

  .qchip.save:hover {
    background: var(--surface-hover)
  }
  /* @css list/QueryChips end */
</style>
